/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Remove_Video_File_LabelInputs */

const en_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove video file`)
};

const fr_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le fichier vidéo`)
};

const de_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodatei entfernen`)
};

const it_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi file video`)
};

const ru_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить видеофайл`)
};

const es_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar archivo de vídeo`)
};

const zh_cn2_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除视频文件`)
};

const ja_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイルを削除する`)
};

const hi_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल हटाएँ`)
};

const pt_pt2_audio_description_export_remove_video_file_label = /** @type {(inputs: Audio_Description_Export_Remove_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover arquivo de vídeo`)
};

/**
* | output |
* | --- |
* | "Remove video file" |
*
* @param {Audio_Description_Export_Remove_Video_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_remove_video_file_label = /** @type {((inputs?: Audio_Description_Export_Remove_Video_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Remove_Video_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_remove_video_file_label(inputs)
	if (locale === "de") return de_audio_description_export_remove_video_file_label(inputs)
	if (locale === "it") return it_audio_description_export_remove_video_file_label(inputs)
	if (locale === "ru") return ru_audio_description_export_remove_video_file_label(inputs)
	if (locale === "es") return es_audio_description_export_remove_video_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_remove_video_file_label(inputs)
	if (locale === "ja") return ja_audio_description_export_remove_video_file_label(inputs)
	if (locale === "hi") return hi_audio_description_export_remove_video_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_remove_video_file_label(inputs)
	return en_audio_description_export_remove_video_file_label(inputs)
});